export var isRenderProp=function(a){return"function"==typeof a};
//# sourceMappingURL=isRenderProp.js.map